<template>
    <div class="page-start">
        <mdb-row class="justify-content-center">
		<mdb-col col="10">
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p1" @closeAlert="p1=false" dismiss>
                There was an error retrieving submitted wars! Please try again later. Error Code P1
            </mdb-alert>
            <mdb-card class="mb-3 d-flex">
                <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Submitted WAR Reports</h3>
                <mdb-card-body>
                    <mdb-input v-if="isAdmin || isSup" class="mb-0 mt-2" type="checkbox" v-model="showReportsTo" id="showReportsTo" name="showReportsTo" label="Show Direct Report WARs"/>

                    <QDataTable :filterWords="this.wars.filterWords" :rowData="this.wars.rowData" :headers="this.wars.columns" 
                        :hasBtn="true" :btnName="'Download'" @use-method="downloadPDF"
                        :hasBtn2="true" :btnName2="'Preview'" @use-method-2="previewPDF"
                        :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}"
                    />
                    <div :class="{'hideSpinner': isSetUp}" class="p-4">
                        <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </mdb-col>
        </mdb-row>
    </div>
</template>

<script>
import { mdbCol, mdbRow, mdbAlert, mdbInput, mdbCard, mdbCardBody } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';

import * as PDFDownload from '@/assets/js/downloadPDF.js';

export default {
    name: 'EditSavedWar',
    components: {
        mdbCol,
        mdbRow,
        mdbAlert,
        QDataTable,
        mdbInput,
        mdbCard, 
        mdbCardBody
    },
    data() {
        return {
            isSup: false,
            isAdmin: false,
            showReportsTo: false,
            isSetUp: false,
            wars: {
                columns: [
                    {
                        colTitle: 'Date Range',
                        sortBy: 'dateSubmitted'
                    },
                    {
                        colTitle: 'Project',
                        sortBy: 'projectTask'
                    },
                    {
                        colTitle: 'Action',
                        sortBy: ''
                    }
                ],
                rowData: [],
                filterWords: [
                    'dateSubmitted',
                    'projectTask'
                ]
            },
            p1: false
        }
    },
    methods: {
        fillTable: async function() {
            let token = this.$store.getters.getToken;
            let query = '';
            let response = '';
            if(this.$store.getters.getGroups.includes('Administration') || this.$store.getters.getGroups.includes('Supervisor')){
                this.wars = {
                    columns: [
                        {
                            colTitle: 'Date Range',
                            sortBy: 'dateSubmitted'
                        },
                        {
                            colTitle: 'Project',
                            sortBy: 'projectTask'
                        },
                        {
                            colTitle: 'Name',
                            sortBy: 'name'
                        },
                        {
                            colTitle: 'Action',
                            sortBy: ''
                        }
                    ],
                    rowData: [],
                    filterWords: [
                        'dateSubmitted',
                        'projectTask',
                        'name'
                    ]
                }
            }
            if(this.isAdmin && this.showReportsTo){
                try 
                {
                    query = query + '&filters[submitted][$eq][0]='+true;
                    response = await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
                } 
                catch 
                {
                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p1 = true;
                    return;
                }
            }
            else if(this.isSup  && this.showReportsTo) {
                try 
                {
                    query = 'filters[blocked][$eq][0]='+false+'&filters[$or][1][reportsTo][$eq]='+this.$store.getters.getUser+'&filters[$or][2][username][$eq]='+this.$store.getters.getUser;
                    response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
                    query = 'filters[submitted][$eq][0]='+true;
                    let counter = 0;
                    response.data.forEach(tableRow => {
                        counter = counter + 1;
                        query = query + '&filters[username][$in]['+counter+']='+tableRow.username;
                    })
                    response = await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
                } 
                catch 
                {
                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p1 = true;
                    return;
                }
            } else {
                try {
                    query = 'filters[submitted][$eq][0]='+true+'&filters[username][$eq][1]='+this.$store.getters.getUser;
                    response = await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
                } catch(error) {
                    window.scroll({top: 0, behavior: 'smooth'});
                    this.p1 = true;
                    return;
                }
            }
            if(response != ''){
                response.data.data.forEach(tableRow => {
                    //let startDate = new Date(tableRow.attributes.startDate)
                    //let endDate =  new Date(tableRow.attributes.endDate)
        
                    this.wars.rowData.push({
                        id: tableRow.id,
                        name: tableRow.attributes.firstLastName,
                        dateSubmitted: tableRow.attributes.startDate + " - " + tableRow.attributes.endDate,//(startDate.getUTCMonth() + 1) + "/" + startDate.getUTCDate() + "/" + startDate.getUTCFullYear().toString().substr(-2) + " - " + (endDate.getUTCMonth() + 1) + "/" + endDate.getUTCDate() + "/" + endDate.getUTCFullYear().toString().substr(-2),
                        projectTask: tableRow.attributes.projectTask,
                        activity: tableRow.attributes.activity,
                        division: tableRow.attributes.division,
                    })
                });
            }
            this.isSetUp = true;
            return 0;
        },

        downloadPDF: function(war) {
            PDFDownload.fileDownload(war.id, war.projectTask, war.activity, war.name, war.dateSubmitted, war.division, 'Download')
        },

        previewPDF: function(war) {
            PDFDownload.fileDownload(war.id, war.projectTask, war.activity, war.name, war.dateSubmitted, war.division, 'Preview')
        },

        checkGroups: function(){
        if (this.$store.getters.getGroups.includes("Administration")){
          this.isAdmin = true;
        }
        if (this.$store.getters.getGroups.includes("Supervisor")){
          this.isSup = true;
        }
      },
    },
     watch: {
        showReportsTo: function() {
            this.fillTable();
        }
    },

    mounted() {
        this.fillTable();
        this.checkGroups();
    }
    
}
</script>
